import React, { useState } from "react";
import {
  Container,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
} from "reactstrap";
import "./slackVerificationPages.css"; // Import your custom styles
import daniIcon from "../../../assets/dani_icon.svg";
import { connect } from "react-redux";
import InitialLinkButton from "../../../components/SlackAndTeamsPopups/InitialLinkButton";
import { baseUrl, serverAuthBaseUrl } from "../../../utils/constants";
import { BiLogoSlack } from "react-icons/bi";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import OoPopover from "../../../components/UI/Popover/OoPopover";
import slackInfo from "../../../assets/add-slack-url.png";
import * as actionCreators from "../../../modules/actions"
import { toastContainer } from "../../../utils/toast";

const DaniLandingPage = ({ user,orgChangeSuccess }) => {
  const [workspaceId, setWorkspaceId] = useState("");
  const [workspaceName, setWorkspaceName] = useState("");
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  // Validate workspaceId format {workspace_id}.slack.com
  const validateWorkspaceId = (id) => {
    const regex = /^[a-zA-Z0-9_-]+\.slack\.com$/;
    return regex.test(id);
  };

  // Handle input changes and enable button if both fields are valid
  const handleInputChange = () => {
    if (workspaceId && validateWorkspaceId(workspaceId) && workspaceName) {
      setIsButtonEnabled(true);
    } else {
      setIsButtonEnabled(false);
    }
  };

  const handleWorkspaceIdChange = (e) => {
    setWorkspaceId(e.target.value);
    handleInputChange();
  };

  const handleWorkspaceNameChange = (e) => {
    setWorkspaceName(e.target.value);
    handleInputChange();
  };

  const redirectUrl = serverAuthBaseUrl() + "public/slack-auth";

  const userId = user.profile._id;
  const orgId = user.profile.organizationId;

  const handleAddToSlack = () => {
    let orgId = user.profile.organizationId._id;
    const data = {
      workspaceId,
      workspaceName,
      createdOn: new Date(),
    };
    setLoading("Loading...")
    axios
      .post(url.addSlackWorkspaceUrl, { url: data, orgId })
      .then(({ data }) => {

        if (data && data.data) {
          orgChangeSuccess(data.data);
          window.open(
            `https://slack.com/oauth/v2/authorize?client_id=340811567938.5227436336544&scope=chat:write,chat:write.public,incoming-webhook,channels:read,groups:read,im:read,mpim:read,app_mentions:read,users:read,users:write,im:write,im:history,im:write.topic,groups:write,mpim:write,usergroups:read,channels:manage&user_scope=channels:read,im:read,mpim:read,groups:read,users:read&state=${orgId}_${userId}&redirect_uri=${encodeURIComponent(
              redirectUrl
            )}`
          );
        }

        setLoading("Done")
      })
      .catch((err) => {
        console.log(err);
        toastContainer("This workspace url is already added, Please enter a new slack workspace url","error")
        setLoading(false)
      });
  };

  return (
    <Container >
      <div className="landing-page">
      <h1 className="landing-title">Dani + Slack</h1>

<div className="d-flex justify-content-center landing-page-icons-container" style={{gridGap:'3em'}}>
  <img
    className="dani-icon"
    style={{
      width: "105px",
      display: "block",
    }}
    src={daniIcon}
  />
  <img class="slack-button-integration" src="https://a.slack-edge.com/80588/marketing/img/meta/slack_hash_256.png" ></img>
</div>
{/* <p className="landing-description mt-4">
  Dani is designed to share and promote diversity, equity, and inclusion
  (DEI) content across your Slack workspace. By fostering a more inclusive
  work environment, Dani helps you seamlessly share educational resources,
  articles, and news from OurOffice to Slack, ensuring your team stays
  informed and engaged.
</p> */}

<div className="my-4">
  <div class="installation-steps">
    <h2>Installation Steps</h2>
    <ol>
      <li>
        Add your workspace URL and workspace name in the input fields
        provided.{" "}
        <OoPopover
          target={"tooltip_where_slack_url"}
          placement="bottom"
          css_class="sltm-css-es"
          headerText="Where is my slack url?"
          bodyText={
            <span>
              {/* Open your slack web application in (any) browser and copy the url. If you are using the Slack desktop application (see image below), click on the workspace name on the top left, copy the Slack url into the browser to be taken to the Slack web application. Then, like in the first scenario, copy the url and paste it. */}
              Open your slack web application or slack desktop application
              (see image below), click on the workspace name on the top
              left and copy the Slack url (eg: acmeinc.slack.com) and
              paste it.
              <img className="es-img-po" src={slackInfo} />
            </span>
          }
        />
      </li>
      <li>
        After entering the information, click the <em>Connect Slack</em>{" "}
        button.
      </li>
      <li>
        You will be redirected to the Slack installation page. On that
        page, select the added workspace from the dropdown at the top
        right.
      </li>
      <li>
        Select the channel you want to add Dani to, and then click{" "}
        <em>Allow</em>.
      </li>
      <li>
        After that, you will be redirected back to the app. Go to the
        culture app and click on the <em>Share</em> icon at the bottom of
        any post.
      </li>
      <li>
        Select <em>Share via Slack</em>, and you will see the channel you
        added in the popup. Click the <em>Share</em> button to share the
        post via the Dani app.
      </li>
    </ol>
  </div>
</div>

<Form className="landing-form">
  <FormGroup>
    <Label for="workspaceId">Workspace ID</Label>
    <Input
      type="text"
      id="workspaceId"
      placeholder="your-workspace-id.slack.com"
      value={workspaceId}
      onChange={handleWorkspaceIdChange}
      className={validateWorkspaceId(workspaceId) ? "valid" : "invalid"}
    />
  </FormGroup>

  <FormGroup>
    <Label for="workspaceName">Workspace Name</Label>
    <Input
      type="text"
      id="workspaceName"
      placeholder="Enter your workspace name"
      value={workspaceName}
      onChange={handleWorkspaceNameChange}
    />
  </FormGroup>

  <div className="mt-3 mb-5 pb-4">
    {loading ? (
      <h5 className="text-center">{loading}</h5>
    ) : (
      <InitialLinkButton


       disabled={!isButtonEnabled}
        iconComp={<BiLogoSlack color="white" size={22} />}
        text={"Connect Slack"}
        onClick={() => {
          handleAddToSlack();
        }}
        type="SLACK"
      />
    )}
  </div>
</Form>

{/* <div className="my-5"></div> */}

<footer className="footer">
  <Row>
    <Col>
      <a
        href={`${baseUrl()}home/dani/terms`}
        target="_blank"
        className="footer-link"
      >
        Terms of Use
      </a>
    </Col>
    <Col>
      <a
        href={`${baseUrl()}home/dani/data-policies`}
        target="_blank"
        className="footer-link"
      >
       Data policies
      </a>
    </Col>
    <Col>
      <a
        href={`${baseUrl()}home/dani/support`}
        target="_blank"
        className="footer-link"
      >
      Support
      </a>
    </Col>

    
  </Row>
</footer>
      </div>
     
    </Container>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    orgChangeSuccess:(data) => dispatch(actionCreators.orgChangeSuccess(data))
  };
};
const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DaniLandingPage);
